var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFill28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.279 7l1.29 15.898c0 .886.717 1.602 1.603 1.602h7.71c.887 0 1.603-.716 1.603-1.602L20.76 7H7.28zm3.369 14.492L10.28 8.75h1.012l.377 12.742h-1.022zm3.844 0h-.984V8.75h.984v12.742zm2.86 0h-1.017l.372-12.742h1.012l-.367 12.742zm2.554-16.46h-1.968l-1.439-1.259a1.108 1.108 0 00-.722-.273h-3.543c-.268 0-.53.098-.733.273l-1.438 1.258h-1.97c-.962 0-1.64.46-1.64 1.422h15.094c0-.962-.678-1.422-1.64-1.422z"
  })));
}
export default SvgDeleteFill28;